var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useField } from 'formik';
import { FormText } from '@ally/metronome-ui';
import { useRegisterError } from '../../utils';
const MaskedFormTextInput = (_a) => {
    var { name, value, validate, onBlur, onFocus, onChange, mask, inputType, maxLength, minLength, characterCounter } = _a, props = __rest(_a, ["name", "value", "validate", "onBlur", "onFocus", "onChange", "mask", "inputType", "maxLength", "minLength", "characterCounter"]);
    const [field, meta, helpers] = useField(Object.assign(Object.assign({}, props), { name,
        validate }));
    const { refValue } = useRegisterError(meta.error);
    const getInitialDisplayValue = () => {
        if (value) {
            return (refValue === null || refValue === void 0 ? void 0 : refValue.current) === document.activeElement
                ? value
                : mask(value);
        }
        return '';
    };
    const [displayedValue, setDisplayedValue] = React.useState(getInitialDisplayValue);
    const combinedOnBlur = (e) => {
        if (onBlur) {
            onBlur(e);
        }
        helpers.setValue(e.target.value);
        field.onBlur(e);
        const maskedValue = mask(e.target.value);
        setDisplayedValue(maskedValue);
    };
    const combinedOnFocus = (e) => {
        if (onFocus) {
            onFocus(e);
        }
        setDisplayedValue(field.value);
    };
    const combinedOnChange = (e) => {
        if (onChange) {
            onChange(e);
        }
        setDisplayedValue(e.target.value);
        helpers.setValue(e.target.value);
        field.onChange(e);
    };
    const errorMessage = meta.touched ? meta.error : '';
    return (React.createElement(FormText, Object.assign({ variant: "input", errorNotification: { message: errorMessage }, ref: refValue, name: name, id: name, onBlur: combinedOnBlur, onFocus: combinedOnFocus, onChange: combinedOnChange, value: displayedValue || '' }, (inputType === 'number'
        ? { inputType }
        : {
            inputType,
            maxLength,
            minLength,
            characterCounter,
        }), props)));
};
export default MaskedFormTextInput;
//# sourceMappingURL=MaskedTextInput.js.map